// extracted by mini-css-extract-plugin
export var container = "SectionSliderCaption-module--container--a6f28";
export var cta = "SectionSliderCaption-module--cta--b27e4";
export var description = "SectionSliderCaption-module--description--87c33";
export var subtitle = "SectionSliderCaption-module--subtitle--ae91d";
export var title = "SectionSliderCaption-module--title--889c6";